export const UPDATE_CHECK_DEBOUNCE_MS = 1_000;

export function shouldCheckForUpdate(
  visibilityState: DocumentVisibilityState,
  lastCheckAt: number,
  now: number,
) {
  return visibilityState === 'visible' && now - lastCheckAt >= UPDATE_CHECK_DEBOUNCE_MS;
}

export function registerPwaUpdates() {
  if (!('serviceWorker' in navigator) || !import.meta.env.PROD) return;

  window.addEventListener('load', () => {
    void navigator.serviceWorker
      .register('/sw.js', { updateViaCache: 'none' })
      .then((registration) => {
        const hadController = Boolean(navigator.serviceWorker.controller);
        let reloading = false;
        let lastCheckAt = 0;

        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (!hadController || reloading) return;
          reloading = true;
          window.location.reload();
        });

        const checkForUpdate = () => {
          const now = Date.now();
          if (!shouldCheckForUpdate(document.visibilityState, lastCheckAt, now)) return;
          lastCheckAt = now;
          void registration.update().catch(() => {
            // A later foreground event will retry if the network is temporarily unavailable.
          });
        };

        checkForUpdate();
        document.addEventListener('visibilitychange', checkForUpdate);
        window.addEventListener('focus', checkForUpdate);
        window.addEventListener('pageshow', checkForUpdate);
      })
      .catch(() => {
        // The online app remains usable even if service-worker registration is unavailable.
      });
  });
}
